import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-meal-ticket-selector',
  templateUrl: './meal-ticket-selector.component.html',
  styleUrls: ['./meal-ticket-selector.component.scss']
})
export class MealTicketSelectorComponent implements OnInit, OnChanges {

  @Input() maxNumberOfUnits: number = 24;
  @Input() mealTicketsOptions: number[] = [];
  @Input() selectedQuantity: number | null = null;
  @Input() fixWidth?: number;
  @Input() clearable: boolean = true;
  @Input() placeHolder: string = 'PLACE_ORDER.TICKET_NUMBER';
  @Input() ariaLabel: string = '';

  @Output() selectedQuantityChange = new EventEmitter<number>();

  displayedMealTicketsOptions: number[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.displayedMealTicketsOptions = this.mealTicketsOptions.filter(n => n <= this.maxNumberOfUnits);
  }

  setCurrentMealTicketsNumber(quantity: number): void {
    this.selectedQuantity = quantity;
    this.selectedQuantityChange.emit(quantity);
  }
}
